import { useCallback, useEffect, useState } from 'react'

export function useIntersectionSentinel(opts: {
  enabled: boolean
  onIntersect: () => void
  rootMargin?: string
}) {
  const { enabled, onIntersect, rootMargin } = opts
  const [node, setNode] = useState<HTMLDivElement | null>(null)

  const ref = useCallback((el: HTMLDivElement | null) => {
    setNode(el)
  }, [])

  useEffect(() => {
    if (!enabled) return
    if (!node) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) onIntersect()
      },
      { root: null, rootMargin: rootMargin ?? '600px 0px' },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [enabled, node, onIntersect, rootMargin])

  return { ref }
}
